"use client";
import { jsx as e, jsxs as p } from "react/jsx-runtime";
import { forwardRef as d, createElement as h } from "react";
import y from "../../elements/PersonCard/PersonCard.js";
import { withCmsDataHandling as f } from "../../../handlers/withCmsDataHandling/withCmsDataHandling.js";
import u from "../../layout/Container/Container.js";
import { useMatches as C, Group as g, Heading as v, Grid as x, rem as P, sharedHandler as z } from "@ingeniorforeningen/figurine-core";
import { employeeCardsDeliveryApiParser as E } from "./EmployeeCards.helpers.js";
import '../../../assets/EmployeeCards.css';const N = "_root_nl5cd_2", _ = {
  root: N
}, o = d(
  (a, n) => {
    const { items: t, title: s, ...i } = a, r = t.length < 3 ? "horizontal" : "vertical", l = C({
      base: 1,
      sm: r === "horizontal" ? 1 : 2,
      lg: r === "horizontal" ? 1 : 3
    });
    return /* @__PURE__ */ e(u, { ref: n, ...i, size: "lg", children: /* @__PURE__ */ p(g, { spacing: "lg", direction: "column", className: _.container, children: [
      /* @__PURE__ */ e(v, { type: "h2", variant: "primary", generateAnchor: !0, text: s || "" }),
      /* @__PURE__ */ e(x, { container: !0, columns: l, spacing: P("24px"), children: t.map((m, c) => /* @__PURE__ */ h(y, { ...m, key: c, orientation: r })) })
    ] }) });
  }
);
o.displayName = "PersonCards";
const A = f({
  Component: z(o),
  deliveryApiParser: E
});
A.displayName = o.displayName;
export {
  _ as E,
  o as _EmployeeCards,
  A as default
};
